/* Hawcrest storefront helpers: hero slider, background videos, delivery estimate, sale badge, bundle tier bar. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 768px)') : { matches: false };

  /* ---------- background videos ---------- */
  function videoSrc(v) {
    var m = v.getAttribute('data-src-mobile');
    var d = v.getAttribute('data-src-desktop');
    return (mobileMQ.matches && m) ? m : d;
  }
  function loadVideo(v) {
    var src = videoSrc(v);
    if (!src || v.getAttribute('data-loaded') === src) return;
    v.setAttribute('data-loaded', src);
    v.src = src;
    v.muted = true;
    v.setAttribute('playsinline', '');
  }
  function playVideo(v) {
    if (!v || reduceMotion || v.hasAttribute('data-user-paused')) return;
    loadVideo(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pauseVideo(v) { if (v) v.pause(); }

  /* videos inside media-text sections: play only when visible */
  function initSectionVideos(root) {
    var vids = (root || document).querySelectorAll('.hc-mt [data-hc-video]');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? playVideo(e.target) : pauseVideo(e.target); });
    }, { threshold: 0.25 }) : null;
    vids.forEach(function (v) {
      if (v.hasAttribute('data-hc-init')) return;
      v.setAttribute('data-hc-init', '');
      if (io) io.observe(v); else playVideo(v);
      var btn = v.parentNode.querySelector('[data-hc-video-toggle]');
      if (btn) {
        if (reduceMotion) { btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play video'); v.setAttribute('data-user-paused', ''); }
        btn.addEventListener('click', function () {
          var paused = btn.getAttribute('aria-pressed') === 'true';
          if (paused) { v.removeAttribute('data-user-paused'); reduceMotion = false; playVideo(v); }
          else { v.setAttribute('data-user-paused', ''); pauseVideo(v); }
          btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
          btn.setAttribute('aria-label', paused ? 'Pause video' : 'Play video');
        });
      }
    });
  }

  /* ---------- hero slider ---------- */
  function initHero(hero) {
    if (hero.hasAttribute('data-hc-init')) return;
    hero.setAttribute('data-hc-init', '');
    var slides = hero.querySelectorAll('[data-hc-slide]');
    var dots = hero.querySelectorAll('[data-hc-dot]');
    var pauseBtn = hero.querySelector('[data-hc-pause]');
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 8000;
    var idx = 0, timer = null, paused = reduceMotion;

    function show(i) {
      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) { on ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1'); });
        var v = s.querySelector('[data-hc-video]');
        if (v) { on && !paused ? playVideo(v) : pauseVideo(v); }
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      idx = i;
    }
    function next() { show((idx + 1) % slides.length); }
    function start() { stop(); if (!paused && slides.length > 1) timer = setInterval(next, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hc-dot'), 10)); start(); }); });
    if (pauseBtn) {
      if (paused) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play animation'); }
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        if (!paused) reduceMotion = false;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
        var v = slides[idx] && slides[idx].querySelector('[data-hc-video]');
        if (paused) { stop(); pauseVideo(v); } else { playVideo(v); start(); }
      });
    }
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    show(0); start();
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', function () { show(idx); });
  }

  /* ---------- delivery estimate (business days, US Central time, skips weekends + US federal holidays) ---------- */
  var HOLIDAYS = ['2026-11-26','2026-12-25','2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-06-18','2027-07-05','2027-09-06','2027-10-11','2027-11-11','2027-11-25','2027-12-24','2027-12-31'];
  function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function addBusinessDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(ymd(d)) === -1) n--;
    }
    return d;
  }
  function centralToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = parseInt(p.value, 10); });
      if (o.year && o.month && o.day) return new Date(o.year, o.month - 1, o.day);
    } catch (e) {}
    return null;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-hc-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      var out = el.querySelector('[data-hc-eta]');
      var today = centralToday();
      if (!out || !min || !max || !today) return; /* keeps the "in X–Y business days" fallback */
      var a = addBusinessDays(today, min), b = addBusinessDays(today, max);
      if (isNaN(a.getTime()) || isNaN(b.getTime())) return;
      out.textContent = fmt(a) + ' – ' + fmt(b);
    });
  }

  /* ---------- holiday sale badge (only inside the sale window) ---------- */
  function initSale(root) {
    var now = Date.now();
    (root || document).querySelectorAll('[data-hc-sale]').forEach(function (el) {
      var s = Date.parse(el.getAttribute('data-start')), e = Date.parse(el.getAttribute('data-end'));
      if (now >= s && now < e) el.removeAttribute('hidden');
    });
  }

  /* ---------- bundle tier bar ---------- */
  var tierStops = { 0: 0, 1: 12.5, 2: 25, 3: 62.5 };
  function updateTier(count) {
    count = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-hc-tier]').forEach(function (bar) {
      bar.setAttribute('data-count', count);
      var key = count >= 4 ? 4 : count;
      var msg = bar.querySelector('[data-hc-tier-msg]');
      if (msg) msg.textContent = bar.getAttribute('data-msg-' + key) || '';
      var fill = bar.querySelector('[data-hc-tier-fill]');
      if (fill) fill.style.width = (count >= 4 ? 100 : tierStops[count]) + '%';
      bar.querySelectorAll('[data-step]').forEach(function (st) {
        st.classList.toggle('is-reached', count >= parseInt(st.getAttribute('data-step'), 10));
      });
    });
  }
  window.HawcrestTier = { update: updateTier };

  function refreshTier() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { updateTier(c.item_count); }).catch(function () {});
  }

  /* ---------- bundle & save selector (prices follow the selected variant) ---------- */
  function hcMoney(cents) {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function initBundle(root) {
    (root || document).querySelectorAll('[data-hc-bundle]').forEach(function (box) {
      if (box.hasAttribute('data-hc-init')) return;
      box.setAttribute('data-hc-init', '');
      var form = document.getElementById(box.getAttribute('data-form'));
      if (!form) return;
      var variants = [];
      try { variants = JSON.parse(form.querySelector('[data-variant-json]').value || form.querySelector('[data-variant-json]').textContent); } catch (e) {}
      var select = form.querySelector('[data-product-select]');
      var qtyInput = form.querySelector('[data-hc-qty-input]');
      function syncQty() {
        var c = box.querySelector('[data-hc-qty]:checked');
        if (qtyInput && c) qtyInput.value = c.value;
      }
      box.querySelectorAll('[data-hc-qty]').forEach(function (r) { r.addEventListener('change', syncQty); });
      syncQty();
      var last = null;
      function update() {
        var id = select ? String(select.value) : null;
        if (!id || id === last) return;
        last = id;
        var v = variants.filter(function (x) { return String(x.id) === id; })[0];
        if (!v) return;
        var p = v.price, pct = { 1: 0, 2: 0.10, 3: 0.15 };
        var t = Date.now(), s = Date.parse(box.getAttribute('data-sale-start') || ''), e = Date.parse(box.getAttribute('data-sale-end') || '');
        var sale = !isNaN(s) && !isNaN(e) && t >= s && t < e;
        [1, 2, 3].forEach(function (q) {
          var line = p * q;
          if (sale) line = line - Math.round(line * 0.4);
          var total = line - Math.round(line * pct[q]);
          var now = box.querySelector('[data-hc-bundle-now="' + q + '"]');
          var was = box.querySelector('[data-hc-bundle-was="' + q + '"]');
          if (now) now.textContent = hcMoney(total);
          if (was) was.lastChild.textContent = hcMoney(p * q);
        });
      }
      var section = box.closest('[data-section-type="product"]') || document;
      section.addEventListener('change', function () { setTimeout(update, 60); });
      section.addEventListener('click', function () { setTimeout(update, 120); });
      document.addEventListener('variant:change', function () { setTimeout(update, 0); });
      update();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hc-hero]').forEach(initHero);
    initSectionVideos(root);
    initDelivery(root);
    initSale(root);
    initBundle(root);
    var bar = document.querySelector('[data-hc-tier]');
    if (bar) updateTier(bar.getAttribute('data-count'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) updateTier(e.detail.cart.item_count); else refreshTier();
  });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(refreshTier, 300); });
})();
